<template>
  <div class="container">
    <div class="aloqa_main">
      <div class="contact_info_and_map">
        <div class="contact-info">
          <h4 class="contact-info-header">{{ $t('contactTitle40') }}</h4>
          <h1 class="contact-name mb-0">{{ $t('contactPhone41') }}</h1>
          <div class="d-flex mt-0 align-items-center">
            <i class="bi bi-telephone"></i>
            <span>
              <a :href="'tel:+998712563401'" class="contact-link">+998 71 256 34 01</a>
            </span>
          </div>
          <div>
            <a :href="'tel:+998994343401'" class="contact-link">+998 99 434 34 01</a>
          </div>

          <h5 class="contact-subtitle">{{ $t('contactEmail42') }}</h5>
          <div class="d-flex align-items-center">
            <i class="fas fa-envelope-open-text contact-icon"></i>
            <span>
              <a :href="'mailto:rajabiy20@umail.uz'" class="contact-link">rajabiy20@umail.uz</a>
            </span>
          </div>

          <div class="d-flex mt-3 align-items-center">
            <i class="fas fa-map-marked-alt contact-icon"></i>
            <span style="color: #fff">{{ $t('contactAddress43') }}</span> 
          </div>
        </div>

        <div class="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2997.1797636953806!2d69.25877161132003!3d41.30495280098523!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38ae8b1e4da7574b%3A0x8d6c28796242c206!2z0JTQvtC8LdC80YPQt9C10Lkg0K7QvdGD0YHQsCDQoNCw0LTQttCw0LHQuA!5e0!3m2!1sru!2s!4v1737449107866!5m2!1sru!2s"
            width="100%"
            height="100%"
            style="border: 0"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>

    <div class="meta__container aloqa_main">
      <div class="meta-item" v-for="(item, index) in metaItems" :key="index">
        <span :class="item.iconClass" role="presentation" :aria-label="item.title"></span>
        <div class="meta-item__title">{{ item.title }}</div>
        <div class="meta-item__content">
          <p style="color: #fff" v-for="(content, index) in item.content" :key="index" v-html="content"></p>
          <a v-if="item.link" :href="item.link.url" target="_blank" rel="noopener noreferrer">{{ item.link.text }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    metaItems() {
      return [
        {
          title: this.$t('metaHours45'), 
          iconClass: 'icon-circle icon-circle--hours',
          content: [
            this.$t('metaContentHours48'), 
            this.$t('metaContentHours49')  
          ]
        },
        {
          title: this.$t('metaLocation46'), 
          iconClass: 'icon-circle icon-circle--direction',
          content: [
            this.$t('metaContentLocation50'), 
            this.$t('metaContentLocation51'), 
            // this.$t('metaContentLocation52')  
          ]
        },
        {
          title: this.$t('metaAdmission47'), 
          iconClass: 'icon-circle icon-circle--ticket',
          content: [
            this.$t('metaContentAdmission53'), 
            // this.$t('metaContentAdmission54')  
          ]
        }
      ];
    }
  }
};
</script>


<style scoped>
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.aloqa_main {
  margin-top: 150px;
}

.contact_info_and_map {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.contact-info {
  width: 100%; 
  padding: 25px;
  background-color: #29355B;
  color: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
}

.map-container {
  width: 100%; 
  height: 400px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}

.contact-info-header {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 25px;
  text-transform: uppercase;
}

.contact-subtitle,
.contact-name {
  font-size: 16px;
  color: #fff;
}

.contact-link {
  text-decoration: none;
  color: #fff;
  font-weight: bold;
  padding-left: 7px;
  transition: color 0.3s ease;
  padding: 10px 0 10px 0;
}

.contact-link:hover {
  text-decoration: underline;
}

.contact-icon {
  color: #fff;
  margin-right: 12px;
  font-size: 22px;
}

.meta__container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.meta-item {
  background-color: #29355B;
  padding: 20px;
  margin: 15px;
  width: 100%; 
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  text-align: center;
}

.meta-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.meta-item__title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin: 10px 0;
  color: #fff;
}

.meta-item__content {
  font-size: 14px;
  color: #fff;
}

.meta-item__content a {
  color: #0056b3;
  text-decoration: none;
}

.meta-item__content a:hover {
  text-decoration: underline;
}

@media (min-width: 768px) {
  .contact_info_and_map {
    flex-wrap: nowrap; 
  }

  .contact-info {
    width: 45%; 
  }

  .map-container {
    width: 55%; 
  }

  .meta-item {
    width: 48%; 
  }
}

@media (min-width: 1024px) {
  .contact_info_and_map {
    gap: 30px; 
  }

  .meta-item {
    width: 30%; 
  }
}
</style>
